import config from "../config";
import EncryptHelper from "../helpers/EncryptHelper";

export default class UserDAO {
	static _key = EncryptHelper.encryptKey(config.DAO.prefix + "user");

	static get() {
		const user = EncryptHelper.decrypt(localStorage.getItem(UserDAO._key));

		if (user) {
			return JSON.parse(user);
		}

		return null;
	}

	static set(user) {
		let userStringfy = JSON.stringify(user);

		userStringfy = EncryptHelper.encrypt(userStringfy);
		localStorage.setItem(UserDAO._key, userStringfy);
	}

	static remove() {
		let property = JSON.stringify({
			rules: ["public"]
		});

		property = EncryptHelper.encrypt(property);
		localStorage.setItem(UserDAO._key, property);
	}

	static getProperty(prop) {
		const user = UserDAO.get();

		if (user && user[prop]) {
			return user[prop];
		}

		return null;
	}

	static setProperty(prop, value) {
		const user = UserDAO.get();

		if (user) {
			user[prop] = value;
			UserDAO.set(user);
		}
	}

	static removeProperty(prop) {
		const user = UserDAO.get();

		if (user && user[prop]) {
			delete user[prop];
			UserDAO.set(user);
		}
	}
}

